export const TEST_ID = 'droneCard';
